<template lang="pug">
div
  template
    .mercuryo-deposit-block

      section.regular-form.horizontal
        .form-step
          form(role="form")
            .form-groups-container

              horizontal-form-group(:label="$t('Получатель')" :required="true" :has-errors="model.errors.hasErrorsSplit('destAccount')" )
                div.elements
                  prime-dropdown-accounts(:disabled="formDisabled" :accounts="filteredAccounts" v-model="model.values.destAccount")
                template(v-if="model.errors.hasErrorsSplit('destAccount')")
                  div
                  form-error-message-block(:errors="model.errors" attribute="phone")
                div
                div
                  //div.help-block
                    template {{$t('Номер в формате {num}.', {num: '+7 903 123 45 67'})}}

              horizontal-form-group.my-hint-block(v-if="isEthereum")
                template(v-slot:label)
                  .control-label
                    i.glyphicon.glyphicon-question-sign.hint-panel-question-icon.warning-icon
                div
                  payout-hint-panel(:heading="$t('Пополнение Ethereum счета')" :warning="true")
                    //p {{$t('ethereum_min')}}

                    i18n(path="ethereum_min_eth" tag="p")
                      template(v-slot:min)
                        strong.no-wrap {{model.minimumForCurrency('ETH')|moneyFormat('ETH')}} ETH
                    p {{$t('six_confirmations_ethereum')}}

              horizontal-form-group.my-hint-block(v-if="isBitcoin")
                template(v-slot:label)
                  .control-label
                    i.glyphicon.glyphicon-question-sign.hint-panel-question-icon.warning-icon
                div
                  payout-hint-panel(:heading="$t('Пополнение Bitcoin счета')" :warning="true")
                    p {{$t('six_confirmations_bitcoin')}}

              template(v-if="selectedCurrency")
                //  && !hasGeneratingAddresses
                horizontal-form-group(:label="$t('Адрес для пополнения')" :required="true" :has-errors="model.errors.hasErrorsSplit('wallet')" )
                  div
                    dropdown-crypto-addresses(:addresses="addresses" v-model="selectedAddress" :disabled="formDisabled")
                  div
                  div
                    // div.help-block
                      template {{$t('Эта сумма будет зачислена на счет Capitalist.')}}

                //horizontal-form-group(:label="$t('Комиссия')" :required="false")
                  div
                    //payout-fee-estimate-block(:model="feeModel" :amount="model.values.amount" :currency="model.values.currency" ref="fee" @taxfail="onTaxFail")

                horizontal-form-group(:label="$t('Сумма')" :required="true" :has-errors="model.hasAmountErrors" )
                  div
                    .input-group
                      input(type="text" v-model="model.values.amount"  :disabled="formDisabled" :class="{disabled: formDisabled}").form-control
                      .input-addon
                        div {{selectedCurrency }}
                  //template(v-if="model.errors.hasErrorsSplit('amount')")
                    div
                    form-error-message-block(:errors="model.errors" attribute="amount")
                  div
                  div
                    div.help-block
                      i18n(path="min_hint" tag="p")
                        template(v-slot:min)
                          strong.no-wrap {{ model.minimumForCurrency(selectedCurrency)|moneyFormat(selectedCurrency)}}
                        template(v-slot:cur)
                          strong.no-wrap {{ selectedCurrency}}

              template(v-if="selectedGeneratingAddresses")
                horizontal-form-group
                  p {{$t('Подождите, генерируются адреса, необходимые для пополнения...')}}

              horizontal-form-group.my-hint-block
                template(v-slot:label)
                  .control-label
                    i.glyphicon.glyphicon-question-sign.hint-panel-question-icon
                div
                  payout-hint-panel(:heading="$t('Платеж через партнера', {partner_site: 'Mercuryo.io'})")
                    template {{$t('hint_text', {partner_site: 'Mercuryo.io'})}}

              //horizontal-form-group.my-hint-block
                template(v-slot:label)
                  .control-label
                    i.glyphicon.glyphicon-question-sign.hint-panel-question-icon
                div
                  payout-crypto-currency-notice(:amount="1" source-currency="USD" dest-currency="BTC")

              br
              horizontal-form-group.form-group-buttons
                div.my-buttons-row
                  // a(href="#" @click.prevent="gotoAccountEdit"  :class="{disabled: formDisabled}").btn.btn-warning {{$t('Назад')}}
                  a(href="#" @click.prevent="submit"  :disabled="submitDisabled" :class="{disabled: submitDisabled}").btn.btn-success
                    template(v-if="redirecting") {{$t('Страница оплаты открывется в новом окне...')}}
                    template(v-else) {{$t('К оплате')}}
</template>

<script lang="ts">
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { MercuryoDepositModel } from '@/views/pages/finance/deposit/mercuryo';
import HorizontalFormGroup from '@/components/forms/horizontal/HorizontalFormGroup.vue';
import FormErrorMessageBlock from '@/components/forms/payout/ErrorMessageBlock.vue';
import PayoutHintPanel from '@/components/forms/payout/PayoutHintPanel.vue';
import DropdownKeyvalue from '@/components/forms/dropdown/DropdownKeyValue.vue';
import DropdownCryptoAddresses from '@/components/forms/dropdown/DropdownCryptoAddresses.vue';
import { formatUnixDateFilter } from '@/models/filters/datetime';
import { MoneyFormatFilter } from '@/models/filters/money';
import PrimeDropdownAccounts from "@/components/forms/dropdown/PrimeDropdownAccounts.vue";

@Component({
  name: 'mercuryo-deposit-block',
  components: {
    PrimeDropdownAccounts,
    DropdownCryptoAddresses,
    DropdownKeyvalue,
    PayoutHintPanel,
    FormErrorMessageBlock,
    HorizontalFormGroup,
  },
  filters: {
    tsFormat: formatUnixDateFilter,
    moneyFormat: MoneyFormatFilter,
  },
})
export default class MercuryoDepositBlock extends Vue {
  model: MercuryoDepositModel = new MercuryoDepositModel();

  get selectedAddress() {
    return this.model.selectedAddress;
  }

  set selectedAddress(value) {
    this.model.selectedAddress = value;
  }

  selectCurrency(currency: string) {
    for (const account of this.filteredAccounts) {
      if (account.currency === currency) this.model.values.destAccount = account.number;
    }
  }

  get selectedCurrency() {
    return this.model.initState.isLoaded && this.selectedAccount
      ? this.selectedAccount.currency : null;
  }

  get isEthereum(): boolean {
    return this.selectedCurrency === 'ETH';
  }

  get isBitcoin(): boolean {
    return this.selectedCurrency === 'BTC';
  }

  // @Watch('selectedCurrency')
  // onChangeCurrency(newVal) {
  //   if (newVal && (this.addresses.length > 0))
  //   {
  //     this.selectedAddress = this.addresses[0];
  //   }
  // }

  get selectedGeneratingAddresses(): boolean {
    if (!this.selectedAddress) return false;

    return this.selectedAddress.is_generating;
  }

  get hasGeneratingAddresses(): boolean {
    if (!this.model.initState.isLoaded) return false;

    for (const address of this.model.options.wallets) {
      if (address.is_generating) return true;
    }

    return false;
  }

  get selectedAccount() {
    for (const a of this.filteredAccounts) {
      if (a.number === this.model.values.destAccount) return a;
    }
    return null;
  }

  get formDisabled(): boolean {
    return !this.model.initState.isLoaded;
  }

  get submitDisabled(): boolean {
    return !this.selectedAddress || this.formDisabled
        || this.selectedGeneratingAddresses || this.model.modelHasErrors;
  }

  mounted() {
    this.multiReload();
  }

  repeatCount = 5;

  repeatTimeout = 1000;

  multiReload(invisible = false) {
    if (this.repeatCount-- < 0) this.repeatTimeout = 5000;

    return this.model.loadModel(invisible).then(() => {
      if (this.hasGeneratingAddresses) {
        setTimeout(() => {
          this.multiReload(true);
        }, this.repeatTimeout);
      }
    }).catch(() => {
      setTimeout(() => {
        this.multiReload(invisible);
      }, this.repeatTimeout);
    });
  }

  get filteredAccounts() {
    return this.model.initState.isLoaded
      ? this.model.options.accounts : [];
  }

  get addresses() {
    return this.model.initState.isLoaded && this.selectedAccount
      ? this.model.options.wallets.filter((address) => address.currency === this.selectedAccount.currency) : [];
  }

  redirecting = false;

  submit() {
    if (this.selectedAddress) this.redirectToMercuryo(this.selectedAddress);
  }

  redirectToMercuryo(wallet) {
    this.redirecting = true;
    const url = `${wallet.cardDepositUrl as string}&amount=${this.model.values.amount}`;
    setTimeout(() => {
      this.redirecting = false;
    }, 2000);
    const win = window.open(url, '_blank');
    if (win) win.focus();
  }
}
</script>

<style scoped lang="less">
@import "../../../../less-mixins/legacy-flexbox-mixins";
@import "../../../../less-mixins/legacy-mixins";

.input-group {
  display: grid;
  grid-template-columns: auto max-content;

  .input-addon {
    cursor: pointer;
    .flex-display(flex);
    .align-items(center);
    .justify-content(center);

    text-align: center;
    background: #80bd1c;
    color: #fff;
    line-height: 14px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    padding: 0;
  }

  .input-addon::v-deep {
    color: #fff;
    padding: 0 15px;
    /*.dropdown {
      button {
        background: none;
        color: #fff;
        border: none;
        box-shadow: none;
        .box-shadow(none);
      }

      .dropdown_selected {
        margin-right: 25px;
      }
    }

    [data-toggle="dropdown"]:after {

      border-color: #fff transparent transparent transparent;
    }*/
  }
}

.mercuryo-deposit-block {
  padding: 0 150px 1em 0;
  margin-top: 1.5em;
}
.my-hint-block {
  .hint-panel-question-icon {
    color: #5c8f08;
    line-height: 1.4em;
    &.warning-icon {
      color: #eea236;
    }
  }

  //.panel-heading {
  //  margin-bottom: 0;
  //  padding-bottom: 0;
  //}
}

.red {
  color: red;
}

.no-wrap {
  white-space: nowrap;
}

.alert {
  border-radius: 5px;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
}
</style>

<i18n>
{
  "en": {
    "title": "Deposit Capitalist.net account via Visa/Mastercard",
    "Получатель": "Beneficiary",
    "Адрес для пополнения": "Deposit address",
    "К оплате": "Next",
    "Платеж через партнера": "Payment via {partner_site}",
    "Подождите, генерируются адреса, необходимые для пополнения...": "Please wait while generating crypto addresses...",
    "hint_text": "You will be redirected to {partner_site} to complete your payment.",
    "Пополнение Ethereum": "Deposit Ethereum",
    "Пополнение Bitcoin": "Deposit Bitcoin",
    "Пополнение Ethereum счета": "Deposit Ethereum",
    "Пополнение Bitcoin счета": "Deposit Bitcoin",
    "six_confirmations_bitcoin": "After receiving six network confirmations, the funds will be credited to your account.",
    "six_confirmations_ethereum": "After receiving six network confirmations, the funds will be credited to your account.",
    "ethereum_min": "Minimum deposit amount is 0.1 ETH. Smaller amount transactions will not be deposited on your Capitalist account.",
    "ethereum_min_eth": "Minimum deposit amount is {min}. Smaller amount transactions will not be deposited on your Capitalist account.",
    "min_hint": "Minimum deposit amount: {min} {cur}.",
    "Сумма": "Amount"
  },
  "ru": {
    "Платеж через партнера": "Платеж через {partner_site}",
    "title": "Пополнение счета Capitalist.net с банковской карты Visa/Mastercard",
    "hint_text": "Для завершения платежа вы будете автоматически перенаправлены на страницу оплаты.",
    "six_confirmations_bitcoin": "После получения шести подтверждений сети средства будут зачислены на ваш счет.",
    "six_confirmations_ethereum": "После получения шести подтверждений сети средства будут зачислены на ваш счет.",
    "ethereum_min": "Минимальная сумма пополнения для переводов Ethereum: 0.1 ETH. В случае отправки перевода на сумму менее 0.1 ETH средства не будут зачислены на счет Capitalist.",
    "ethereum_min_eth": "Минимальная сумма пополнения для переводов Ethereum: {min}. В случае отправки перевода на сумму менее {min} средства не будут зачислены на счет Capitalist.",
    "min_hint": "Минимальная сумма пополнения: {min} {cur}."
  }
}
</i18n>
